import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild, ElementRef, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, NgForm, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common'
import { config } from 'src/app/config/config';

// import { config } from 'src/app/valueObject/config';
import { UserDetailsService } from 'src/app/service/user-details.service';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { Subject, throwError } from 'rxjs';
import { Title } from '@angular/platform-browser';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
declare var $: any;
pdfMake.vfs = pdfFonts.vfs;

import { NgxSpinnerService } from 'ngx-spinner';
import { SgrbService } from 'src/app/service/sgrb.service';
import { ForexDerivativesService } from 'src/app/service/forex-derivatives.service';
import { DatatableService } from 'src/app/service/datatable.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit{
  
  config: any = config;
  message: string;
  userDetails: any;
  access: any = {};
  user: any = {};
  loginId: any;
  entityType: any;
  entityCode:any;
  subscription: any;
  tradeData : any;
  dtTrigger: Subject<any> = new Subject<any>();
  dtOptions: any;
  selectedTrade: string = '';
  searchForm: FormGroup = this.formBuilder.group({});
  entityCodeArray: any[] = [];
  bsValue: any[] = [];

  dealStatus = ['Approved','Rejected','Submitted'];


  constructor(
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private userService: UserDetailsService,
    private userDetailsService: UserDetailsService,
    private router: Router,
    private toastr: ToastrService,
    private cdref: ChangeDetectorRef,
    private titleService: Title,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,
    private sgrbService: SgrbService,
    private fsService: ForexDerivativesService,
    private dataTableService: DatatableService
  ) { }

  ngOnInit(): void {
    this.titleService.setTitle('Foreign Currency Options');
    this.user = this.userDetailsService.getUserDetails() || {};
    this.entityType = this.user.entityType;
    this.entityCode = this.user.entityCode;
    this.loginId = this.user.userId;
    this.getAllSrgbTardes();
    this.setSearchForm();
    this.getCounterPartyData();
  }

  getFilteredDeal()
  {
    $("#trdTbl").DataTable().destroy();
    this.sgrbService.getSgrbFilteredTrade(this.searchForm.getRawValue()).pipe(
      catchError((error: any) => {
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.toastr.success(response.message);
        this.tradeData = response.data;
        this.dataTableService.setDatatable("trdTbl", 11, 10, [10, 25, 50, 100]); 
      } else {
        this.tradeData = [];
        this.dataTableService.setDatatable("trdTbl", 11, 10, [10, 25, 50, 100]); 
        this.toastr.error(response.message);
      }
    });
  }

  setSearchForm() {
    this.searchForm = this.formBuilder.group({
      reportingMemId: [{ value: this.entityType == 'MEMBER' ? this.user?.entityCode : '', disabled: this.entityType == 'MEMBER' ? true : false }],
      countrPartyId: [''],
      dealStatus:[''],
      trdDate: [null]
    });
  }

  reset()
  {
    this.setSearchForm();
    this.getAllSrgbTardes();
    this.cdref.detectChanges();
    $('.selectpicker').selectpicker('refresh');
  }

  getCounterPartyData() {
    this.spinner.show();
    this.fsService.getCounterPartyListInterbank().pipe(
      catchError((error: any) => {
        this.spinner.hide();
        this.entityCodeArray = [];
        if (error.statusCode != 200) {
          this.toastr.error(this.config.failureResponse["SOMETHING_WENT_WRONG"]);
        }
        return throwError(error.error)
      })
    ).subscribe((response: any) => {
      this.spinner.hide();
      if (response.statusCode == 200) {
        this.entityCodeArray = response.data;
      } else {
        this.entityCodeArray = [];
      }
      this.cdref.detectChanges();
      $('.selectpicker').selectpicker('refresh');
    })

  }

  getAllSrgbTardes() {
    this.tradeData = [];
    $("#trdTbl").DataTable().destroy();
    this.sgrbService.getAllSgrbTrade().pipe(
      catchError((error: any) => {
        this.tradeData = [];
        this.dataTableService.setDatatable("trdTbl", 11, 10, [10, 25, 50, 100]); 
        this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
        if (error.status != 200) {
          return throwError(error.error);
        }
      })
    ).subscribe((response: any) => {
      if (response.statusCode == 200) {
        this.tradeData = response.data;
        this.dataTableService.setDatatable("trdTbl", 11, 10, [10, 25, 50, 100]); 
      } else {
        this.tradeData = [];
        this.dataTableService.setDatatable("trdTbl", 11, 10, [10, 25, 50, 100]); 
        this.toastr.error(response.message);
      }
    });
  }

  
  newDeal() {
    this.router.navigate(['/sovereignGreenBond/sgrb/addDeal'], { "queryParams": { action: 'newOrder' }, skipLocationChange: false });
  }
  redirectToDeal(id)
  {
    let selectedTrade:any = this.tradeData.find(item=>item.orderId==id);
    this.router.navigate(['/sovereignGreenBond/sgrb/addDeal'], { "queryParams": { action: 'viewOrder',id:selectedTrade.orderId }, skipLocationChange: true });
    
  }

  selectTrade(id) {
    this.selectedTrade = id;
  }
  onCloseModal() {
    this.selectedTrade = "";
  }

  cancelDeal() {
    let dealStatus = this.tradeData.find(data => data.trdId == this.selectedTrade)?.dealType;
    if (dealStatus == 'Rejected') {
      this.toastr.warning('Order is already rejected')
    }
   else  if(dealStatus == 'Approved')
    {
      this.toastr.warning('Trade is not allowed to reject')
    }
    else {
      this.sgrbService.rejectTrade(this.selectedTrade).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.toastr.success(response.message);
          this.getAllSrgbTardes();
        } else {
          this.toastr.error(response.message);
        }
      });
    }
  }

  approveDeal() {
    let dealStatus = this.tradeData.find(data => data.trdId == this.selectedTrade)?.dealType;
    if (dealStatus == 'Rejected') {
      this.toastr.warning('Order is already rejected')
    }
   else  if(dealStatus == 'Approved')
    {
      this.toastr.warning('Trade is not already approved')
    }
    else {
      this.sgrbService.approveTrade(this.selectedTrade).pipe(
        catchError((error: any) => {
          this.toastr.error(this.config.failureResponse.SOMETHING_WENT_WRONG);
          if (error.status != 200) {
            return throwError(error.error);
          }
        })
      ).subscribe((response: any) => {
        if (response.statusCode == 200) {
          this.toastr.success(response.message);
          this.getAllSrgbTardes();
        } else {
          this.toastr.error(response.message);
        }
      });
    }

  }

  setdatatable() {
    $("#trdTbl").DataTable().destroy();
    setTimeout(() => {
      $("#trdTbl").DataTable({
        orderCellsTop: true,
        paging: true,
        responsive: true,
        pageLength: 10,
        lengthMenu: [10, 25, 50, 100],
        processing: true,
        dom: 'Blrtip',
        buttons:
          [{
            extend: 'copy',
            titleAttr: 'Copy',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            },
          }, {
            extend: 'excel',
            titleAttr: 'Export to excel',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            },
            filename: 'SrGBTrade'
          }, {
            extend: 'pdf',
            orientation: 'landscape',
            pageSize: 'A4',
            titleAttr: 'Download as PDF',
            exportOptions: {
              columns: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
            },
            filename: 'SrGBTrade'
          }],
        initComplete: function () {
          this.api().columns().every(function () {
            $('#trdTbl .column-search input').val('');
            $('#trdTbl .column-search select').val('.*');
            $('#trdTbl .column-search').on('keyup change', 'input', function () {
              $('#trdTbl').DataTable()
                .column($(this).parent().index())
                .search(this.value)
                .draw();
            });
            $('#trdTbl .column-search').on('keyup change', 'select', function () {
              $('#trdTbl').DataTable()
                .column($(this).parent().index())
                .search("^" + this.value + "$", true, false, false)
                .draw();
            });
          })
        }
      });
      this.cdref.detectChanges();
    }, 1);
  }


}
